import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import PdfForm from '../PdfForm'
import ShareFrom from '../ShareForm'
import Disclaimer from '../Disclaimer'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { view01ImageOptions } from './views/view01'

class X46Summary extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  render () {
    let imageOptions = view01ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.configuration.transom.Name}
        port={this.props.configuration.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.062357, -0.000963, 0, -2.3e-5, 0.003397, 0.097934, 0, 5.6e-6, 0, 0,
          1, 0, 220.028066, 404.093037, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration.exterior}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption style={{ position: 'relative' }}>
          <h1>
            <Trans defaults='Summary' />
          </h1>
          <h2>
            <Trans defaults='Congratulations!' />
          </h2>
          <p>
            <Trans defaults='You have now configured the basics of an X4<sup>6</sup>. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' />
          </p>

          <PdfForm
            boat='x46'
            country={this.props.country}
            countries={this.props.countries}
            configuration={this.props.configuration}
            code={this.props.code}
          />

          <ShareFrom
            configuration={this.props.configuration}
            boat='x46'
            code={this.props.code}
          />

          <Disclaimer />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46Summary)



// WEBPACK FOOTER //
// ./src/X46/X46Summary.js